import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import "../Styles/Contact.css";
import Form from "../Components/Form/Form";
import { animateScroll as scroll } from "react-scroll";
import TopPageButton from "../Components/TopPage/TopePage";
import Loader from "../Components/Loader/Loader";
import { CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });

    const delay = setTimeout(() => {
      setMapLoaded(true);
      clearTimeout(delay);
    }, 2000); // Adjust the delay as needed
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Contact | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="Feel free to contact me at any time on this page. You Can fill up the form to notify me also."
        />
        <meta
          name="keywords"
          content="Aneeq Ullah Khan, Aneeq Ullah Khan Contact, Contact Aneeq Ullah Khan, Aneeq Khan Contact"
        />
      </Helmet>

      <Navbar />
      <div className="mainDiv">
        <p className="heading-text text-center">Contact Me</p>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 160">
          <path
            fill="#0d1117"
            fill-opacity="1"
            d="M0,64L80,80C160,96,320,128,480,128C640,128,800,96,960,85.3C1120,75,1280,85,1360,90.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className="container mt-3 mb-5">
        <div className="row">
          <div className="col-lg-4">
            <p className="section-text1 mt-3">
              Contact Me For Any Query
              <hr />
            </p>
            <p>Headoffice: &nbsp;North Nazimabad, Karachi, Pakistan.</p>
            <p>
              +92 306-2341354 <hr />
            </p>
            <p>
              aneequllah.khan@outlook.com <hr />
            </p>
            <div className="row mb-5">
              <div className="col-sm-2">
                <a
                  href="https://www.linkedin.com/in/aneeq-ullah-khan/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/fluency/48/linkedin.png"
                    alt="linkedin"
                  />
                </a>
              </div>
              <div className="col-sm-2">
                <a
                  href="https://github.com/AneeqUllahKhan"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/ios-filled/50/github.png"
                    alt="github"
                  />
                </a>
              </div>
              <div className="col-sm-2">
                <a
                  href="https://www.fiverr.com/aneeqkhan17"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/color/48/fiverr.png"
                    alt="fiverr"
                  />
                </a>
              </div>
              <div className="col-sm-2">
                <a
                  href="https://www.facebook.com/Aneequllahkhan.18/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/color/48/facebook-new.png"
                    alt="facebook-new"
                  />
                </a>
              </div>
              <div className="col-sm-2">
                <a
                  href="https://www.instagram.com/aneeqprivv_/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/fluency/48/instagram-new.png"
                    alt="insta-new"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            {mapLoaded ? (
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28941.970654304558!2d67.0212156251717!3d24.940710097931806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f8014fe5943%3A0x11df7a65effb1ef6!2sNorth%20Nazimabad%20Town%2C%20Karachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1693847945556!5m2!1sen!2s"
                width="300"
                height="490"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            ) : (
              <div className="text-center mt-5 mb-5">
                <CircularProgress />
              </div>
            )}
          </div>
          <div className="col-lg-4">
            <Form />
          </div>
        </div>
      </div>
      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default Contact;
